/* unplugin-vue-components disabled */import { render } from "./member_details_brief.vue?vue&type=template&id=77d3fd74&scoped=true"
import script from "./member_details_brief.vue?vue&type=script&lang=js"
export * from "./member_details_brief.vue?vue&type=script&lang=js"

import "./member_details_brief.vue?vue&type=style&index=0&id=77d3fd74&style=true&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77d3fd74"]])

export default __exports__